import React from "react";
import AppLoading from "expo-app-loading";
import Home from "./src/screens/customer/Home";
import { useFonts } from "expo-font";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import OperatorLogin from "./src/screens/operator/login";
import Operator from "./src/screens/operator/operatorHome";
import {
  LOGIN_PATH,
  OPERATOR_PATH,
  MONTHLY_PAYMENT,
  ANNUAL_PAYMENT,
  OTP_PAYMENT,
  SUCCESS_PAYMENT,
  TERMS_AND_CONDITIONS,
  FAILED_PAYMENT,
} from "./src/constants/routePaths";
import MonthlyPayment from "./src/screens/monthlyPayment/monthlyPayment.js";
import AnualPayment from "./src/screens/paymentScreen/index";
import PaymentOtpScreen from "./src/screens/paymentScreen/paymentOtpScreen";
import PaymentSuccessScreen from "./src/screens/paymentScreen/paymentSuccessScreen";
import TermsAndConditions from "./src/screens/customer/TermsAndConditions";
import PaymentFailedScreen from "./src/screens/paymentScreen/paymentFailedScreen";
export default function App(props) {
  let [fontsLoaded] = useFonts({
    SFProText: require("./assets/fonts/SFProText-Regular.ttf"),
    SFProTextBold: require("./assets/fonts/SFProText-Bold.ttf"),
    RoundedMplus1c: require("./assets/fonts/MPLUSRounded1c-Regular.ttf"),
    RoundedMplus1cBold: require("./assets/fonts/MPLUSRounded1c-Bold.ttf"),
  });

  window.__be = window.__be || {};
  window.__be.id = "5b3a47b4b30a36000769d821";
  (function () {
    var be = document.createElement('script');
    be.type = 'text/javascript';
    be.async = true;
    be.nonce = "bm9uY2UtcmFuZG9tMTIj";
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(be, s);

    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      scripts[i].setAttribute('nonce','bm9uY2UtcmFuZG9tMTIj');
      console.log(document.getElementsByTagName('script')[i].nonce);
    }
  })();


  return (
    <Router>

      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}

      <Switch>
        <Route
          path={OPERATOR_PATH}
          render={(props) => <Operator {...props} />}
        ></Route>

        <Route path={LOGIN_PATH}>
          <OperatorLogin props={props} />
        </Route>

        <Route
          path={ANNUAL_PAYMENT}
          render={(props) => <AnualPayment {...props} />}
        ></Route>
        <Route
          path={MONTHLY_PAYMENT}
          render={(props) => <MonthlyPayment {...props} />}
        ></Route>

        <Route
          path={OTP_PAYMENT}
          render={(props) => <PaymentOtpScreen {...props} />}
        ></Route>

        <Route
          path={SUCCESS_PAYMENT}
          render={(props) => <PaymentSuccessScreen {...props} />}
        ></Route>

        <Route
          path={FAILED_PAYMENT}
          render={(props) => <PaymentFailedScreen {...props} />}
        ></Route>
        <Route path={TERMS_AND_CONDITIONS}>
          <TermsAndConditions props={props} />
        </Route>
        <Route path="/">
          <Home props={props} />
        </Route>
      </Switch>
    </Router>
  );
}
